/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Nikolay Sviridov
 * @version 1.33.0
 * @since 1.33.0
 */

import { createAction } from '../../modules/app/createAction';
import {
    IWizardImportSubscribersLimitsAttachFileActionPayload,
    IWizardImportSubscribersLimitsAttachFileSuccessfulActionPayload,
    IWizardImportSubscribersLimitsSetStepValidPayload,
    TWizardImportSubscribersLimitsAttachFile,
    TWizardImportSubscribersLimitsAttachFileFailedAction,
    TWizardImportSubscribersLimitsAttachFileSuccessfulAction,
    TWizardImportSubscribersLimitsHandleNextAction,
    TWizardImportSubscribersLimitsInitValidatedList,
    TWizardImportSubscribersLimitsInitValidatedListFailedAction,
    TWizardImportSubscribersLimitsSetParamsAction,
    TWizardImportSubscribersLimitsSetParamsPayload,
    TWizardImportSubscribersLimitsSetStepValidAction,
    TWizardImportSubscribersLimitsStartValidateAction,
} from './types/wizardImportSubscribersLimitsActionTypes';
import {
    WIZARD_IMPORT_SUBSCRIBERS_LIMITS_ATTACH_FILE,
    WIZARD_IMPORT_SUBSCRIBERS_LIMITS_ATTACH_FILE_FAILED,
    WIZARD_IMPORT_SUBSCRIBERS_LIMITS_ATTACH_FILE_SUCCESSFUL,
    WIZARD_IMPORT_SUBSCRIBERS_LIMITS_HANDLE_NEXT,
    WIZARD_IMPORT_SUBSCRIBERS_LIMITS_INIT_VALIDATED_LIST,
    WIZARD_IMPORT_SUBSCRIBERS_LIMITS_INIT_VALIDATED_LIST_FAILED,
    WIZARD_IMPORT_SUBSCRIBERS_LIMITS_SET_PARAMS,
    WIZARD_IMPORT_SUBSCRIBERS_LIMITS_SET_STEP_VALID,
    WIZARD_IMPORT_SUBSCRIBERS_LIMITS_START_VALIDATE,
} from './wizardImportSubscribersLimitsConstant';

/*
* -------------------------------------------
*         Common Wizard Actions
* -------------------------------------------
*/

export const wizardImportSubscribersLimitsHandleNextAction = (): TWizardImportSubscribersLimitsHandleNextAction =>
    createAction(WIZARD_IMPORT_SUBSCRIBERS_LIMITS_HANDLE_NEXT);

export const wizardImportSubscribersLimitsSetParamsAction = (payload: TWizardImportSubscribersLimitsSetParamsPayload)
    : TWizardImportSubscribersLimitsSetParamsAction =>
    createAction(WIZARD_IMPORT_SUBSCRIBERS_LIMITS_SET_PARAMS, payload);

export const wizardImportSubscribersLimitsStartValidateAction = ():
    TWizardImportSubscribersLimitsStartValidateAction => createAction(WIZARD_IMPORT_SUBSCRIBERS_LIMITS_START_VALIDATE);

export const wizardImportSubscribersLimitsSetStepValidAction = 
    (payload: IWizardImportSubscribersLimitsSetStepValidPayload):
        TWizardImportSubscribersLimitsSetStepValidAction => 
            createAction(WIZARD_IMPORT_SUBSCRIBERS_LIMITS_SET_STEP_VALID, payload);

/*
* -------------------------------------------
*          ATTACH FILE
* -------------------------------------------
*/

export const wizardImportSubscribersLimitsAttachFile = (payload: IWizardImportSubscribersLimitsAttachFileActionPayload):
    TWizardImportSubscribersLimitsAttachFile => createAction(WIZARD_IMPORT_SUBSCRIBERS_LIMITS_ATTACH_FILE, payload);

export const wizardImportSubscribersLimitsAttachFileSuccessful =
    (payload: IWizardImportSubscribersLimitsAttachFileSuccessfulActionPayload):
        TWizardImportSubscribersLimitsAttachFileSuccessfulAction =>
            createAction(WIZARD_IMPORT_SUBSCRIBERS_LIMITS_ATTACH_FILE_SUCCESSFUL, payload);

export const wizardImportSubscribersLimitsAttachFileFailed =
    (payload: any): TWizardImportSubscribersLimitsAttachFileFailedAction =>
        createAction(WIZARD_IMPORT_SUBSCRIBERS_LIMITS_ATTACH_FILE_FAILED, payload);

/*
* -------------------------------------------
*          LOAD TABLE DATA
* -------------------------------------------
*/

export const wizardImportSubscribersLimitsInitValidatedList = (): TWizardImportSubscribersLimitsInitValidatedList =>
    createAction(WIZARD_IMPORT_SUBSCRIBERS_LIMITS_INIT_VALIDATED_LIST);

export const wizardImportSubscribersLimitsInitValidatedListFailed =
    (payload: string): TWizardImportSubscribersLimitsInitValidatedListFailedAction =>
        createAction(WIZARD_IMPORT_SUBSCRIBERS_LIMITS_INIT_VALIDATED_LIST_FAILED, payload);
